export const environment = {
  production: true,
  apiUrl: 'https://api.adapei12-82.fr/api/',
  adminUrl: 'https://control.adapei12-82.fr/',
  basedocUrl: 'https://basedoc.adapei12-82.fr/',
  cookieDomain: 'adapei12-82.fr',
  siteName: 'OPTEO'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts